import { isPhysical } from 'types/guards/product';
import { ProductInterface } from 'types/types';
import {
  SchemaItemAvailabilityEnum,
  SchemaOfferItemConditionEnum,
  SchemaProduct,
} from './types';
import { CURRENCY_CODE } from '../../../constants';
import { trimUrl } from '../../../util/url';
import config from '../../../util/load-config';
import { dateObjectToIso } from '../../../util/date';

const MAPPABLE_CONDITIONS = ['NEW', 'REFURBISHED'];

export const mapProductSchema = (product: ProductInterface): SchemaProduct => ({
  '@type': 'Product',
  name: product.name,
  image: product.image.url,
  brand: {
    '@type': 'Brand',
    name: product.brand,
  },
  offers: [
    {
      '@type': 'Offer',
      price: product.hasPriceRange
        ? product.minPrice.value
        : product.price.value,
      priceCurrency: CURRENCY_CODE,
      url: `${trimUrl(config.site.url)}/products/${product.id}`,
      // active to date
      ...(typeof product.activeToDate === 'string'
        ? {
            priceValidUntil: dateObjectToIso(
              new Date(product.activeToDate),
              false
            ),
          }
        : {}),
      // availability
      availability: !product.isSoldOut
        ? SchemaItemAvailabilityEnum.InStock
        : SchemaItemAvailabilityEnum.OutOfStock,
      // condition (only on physical products, and when they have a mappable condition)
      ...(isPhysical(product) &&
      product.condition &&
      MAPPABLE_CONDITIONS.includes(product.condition.toUpperCase())
        ? {
            itemCondition:
              product.condition.toUpperCase() === 'NEW'
                ? SchemaOfferItemConditionEnum.New
                : SchemaOfferItemConditionEnum.Refurbished,
          }
        : {}),
    },
  ],
});
